import * as React from 'react';
import { useRouteMatch } from 'react-router';

import { getProductView_productDetailByMasterId_variants } from '../../queries/__generated__/getProductView';
import { selectVariant } from '../../utils';
import { IProductDetailRouteParams } from '../index';

export const useCurrentVariant = (
  variants: getProductView_productDetailByMasterId_variants[]
) => {
  const match = useRouteMatch<IProductDetailRouteParams>();

  return React.useMemo(
    () => selectVariant(variants, match.params),
    [variants, match.params]
  );
};
